import { AttSettingT } from 'types/shared/core/Attendance';
import { BillSettingT } from 'types/shared/core/Bill';
import { ChatSettingT } from 'types/shared/core/Chat';
import { HomeworkSettingT } from 'types/shared/core/Homework';
import { EditableMessageSettingT } from 'types/shared/core/Message';

const attendanceUpdatableKeys: (keyof AttSettingT)[] = [
  'shortAcademyName',
  'password',
  'notificationMethod',
  'attCodeBase',
  'adhocNotification',
];

const messageUpdatableKeys: (keyof EditableMessageSettingT)[] = ['autoCharge'];
const chatUpdatableKeys: (keyof ChatSettingT)[] = ['isEnabled'];
const billUpdatableKeys: (keyof BillSettingT)[] = [
  'autoIssueNotificationMethod',
  'sumsAssistantDirectorVisible',
];
const homeworkUpdatableKeys: (keyof HomeworkSettingT)[] = ['reviewer'];

export const ServiceSetting = {
  Attendance: {
    updatableKeys: attendanceUpdatableKeys,
  },
  Message: {
    updatableKeys: messageUpdatableKeys,
  },
  Chat: {
    updatableKeys: chatUpdatableKeys,
  },
  Bill: {
    updatableKeys: billUpdatableKeys,
  },
  Homework: {
    updatableKeys: homeworkUpdatableKeys,
  },
} as const;
